export default [{
  path: '/mine/countryRegion',
  name: 'countryRegion',
  meta: {
    index: 15
  },
  component: () => import('@/views/mine/countryRegion.vue')
}]
